import { VyBaseError } from '@vy/err';
import { FEEDBACK_ERROR_CODES } from './feedback-error-codes';

export class ViewReportNotImplementedError extends VyBaseError {
  constructor() {
    super({
      code: FEEDBACK_ERROR_CODES.VIEW_REPORT_NOT_IMPLEMENTED_ERROR,
      message: 'Not implemented: onViewReport()',
      metadata: {},
    });
  }
}
